import Vue from 'vue';
import {vrmVueModule} from '@/angular-bridge/module';

const injector = Vue.observable({instance: null});

vrmVueModule.run(/* @ngInject */ $injector => {
    injector.instance = $injector;
});

export function injectAngular(service) {
    if (!injector.instance) {
        console.trace('Using injectAngular() before .run()');
        return null;
    } else {
        return injector.instance.get(service);
    }
}
